import * as React from 'react';

import PriceComparison from 'bundles/coursera-plus-landing-page/components/priceComparison/PriceComparison';
import type { LandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/PageContext';
import {
  isAnnualByVariantId as isAnnual,
  isMonthlyByVariantId as isMonthly,
} from 'bundles/coursera-plus/constants/CourseraPlusProductVariant';

type FromLandingPage = {
  landingPage: LandingPageExtended;
};

const PriceComparisonContentful = (props: FromLandingPage) => {
  const { primaryProductItemId, secondaryProductItemId, landingPage } = props.landingPage;
  const { promotionCode } = landingPage;
  if (!secondaryProductItemId) {
    return null;
  }
  if (promotionCode) {
    return null;
  }
  if (isMonthly(primaryProductItemId) && isAnnual(secondaryProductItemId)) {
    return <PriceComparison monthlyProductId={primaryProductItemId} annualProductId={secondaryProductItemId} />;
  }
  if (isAnnual(primaryProductItemId) && isMonthly(secondaryProductItemId)) {
    return <PriceComparison monthlyProductId={secondaryProductItemId} annualProductId={primaryProductItemId} />;
  }
  return null;
};

export default PriceComparisonContentful;
